module.exports = __webpack_public_path__ + "static/flags/BN-d28bb0da5d7c2796f37bf48dd07e6678.gif";